import { Link } from "react-router-dom"
import MarketingLayout from "../../components/marketing/MarketingLayout"
import MarketingSeo from "../../components/marketing/MarketingSeo"
import { measurementStudioSalesMailto } from "../../components/marketing/salesLinks"
import { Button } from "../../components/ui"

const supportMailto = "mailto:support@jarbod.com?subject=Jarbod%20product%20support"

export default function MarketingContact() {
  return (
    <MarketingLayout>
      <MarketingSeo
        title="Contact Jarbod | Measurement Studio"
        description="Contact Jarbod about Measurement Studio, tagging health, data-quality programs, account standards, or ASC TuneUp for automotive."
        path="/contact"
      />
      <section className="marketing-page-hero">
        <div className="marketing-container marketing-page-hero__inner">
          <p className="marketing-eyebrow">Contact Jarbod</p>
          <h1>Tell us how many client accounts your agency needs to keep healthy.</h1>
          <p>
            Share your client count, tagging and analytics platforms, and the
            biggest QA problem your team faces. We will reply with the best-fit
            Measurement Studio program or point automotive teams to ASC TuneUp.
          </p>
        </div>
      </section>

      <section className="marketing-section marketing-section--first">
        <div className="marketing-container marketing-contact-grid">
          <article className="marketing-contact-card marketing-contact-card--primary">
            <p className="marketing-eyebrow">Programs and product fit</p>
            <h2>Tell us about your agency and account portfolio.</h2>
            <p>
              Include your account count, tagging and analytics platforms,
              audit priorities, and any Scale capabilities you want updates about.
            </p>
            <Button as="a" href={measurementStudioSalesMailto} size="lg">Email sales</Button>
            <a className="marketing-contact-email" href={measurementStudioSalesMailto}>hello@jarbod.com</a>
          </article>

          <article className="marketing-contact-card">
            <p className="marketing-eyebrow">Product support</p>
            <h2>Already using a Jarbod product?</h2>
            <p>
              Email support with your organization name, product, and a short
              description of what you need.
            </p>
            <Button as="a" href={supportMailto} variant="outline" size="lg">Email support</Button>
          </article>
        </div>
      </section>

      <section className="marketing-section marketing-section--surface">
        <div className="marketing-container marketing-contact-next">
          <div>
            <p className="marketing-eyebrow">Prefer to explore first?</p>
            <h2>See what Measurement Studio checks.</h2>
          </div>
          <Button as={Link} to="/product" size="lg">Explore the platform</Button>
        </div>
      </section>
    </MarketingLayout>
  )
}

